import { Avatar, Flex } from '@homebotapp/hb-react-component-catalog'
import { Box } from '@homebotapp/hb-react-component-catalog'

interface AvatarBubblesProps {
  photoUri?: string | null
  companyLogo?: string | null
  orientation?: 'vertical' | 'horizontal'
  size?: 'sm' | 'md' | 'lg'
  noOutline?: boolean
}

const sizeMap = {
  sm: {
    avatar: '48px',
    bgCircle: '85px',
    bgSmallCircle: '65px',
    overlap: '8px'
  },
  md: {
    avatar: '71px',
    bgCircle: '114px',
    bgSmallCircle: '85px',
    overlap: '7px'
  },
  lg: {
    avatar: '96px',
    bgCircle: '114px',
    bgSmallCircle: '108px',
    overlap: '14px'
  }
}

export const AvatarBubbles = ({
  photoUri,
  companyLogo,
  orientation = 'horizontal',
  size = 'md',
  noOutline = false
}: AvatarBubblesProps) => {
  const sizes = sizeMap[size]

  return (
    <Flex
      position='relative'
      direction={orientation === 'vertical' ? 'column' : 'row'}
      justifyContent='center'
      alignItems='center'
      p={4}
      borderTopLeftRadius='inherit'
      borderTopRightRadius={['inherit', null, 0]}
      borderBottomLeftRadius={[0, null, 'inherit']}
      minWidth={sizes.bgCircle}
    >
      {/* Background Circles */}
      <Box
        position='absolute'
        width={sizes.bgCircle}
        height={sizes.bgCircle}
        borderRadius='full'
        bg={noOutline ? 'transparent' : 'whiteAlpha.100'}
      />
      <Box
        position='absolute'
        width={sizes.bgSmallCircle}
        height={sizes.bgSmallCircle}
        borderRadius='full'
        bg={noOutline ? 'transparent' : 'whiteAlpha.50'}
      />

      {/* Avatars */}
      <Flex
        position='relative'
        direction={orientation === 'vertical' ? 'column' : 'row'}
        alignItems='center'
        zIndex={1}
      >
        <Avatar
          size={size}
          src={photoUri || undefined}
          width={sizes.avatar}
          height={sizes.avatar}
          marginRight={companyLogo ? `-${sizes.overlap}` : 0}
        />
        {companyLogo && (
          <Avatar
            zIndex={'-10'}
            size={size}
            src={companyLogo}
            width={sizes.avatar}
            height={sizes.avatar}
            marginLeft={`-${sizes.overlap}`}
          />
        )}
      </Flex>
    </Flex>
  )
}
